import * as React from 'react';

import * as Util from '../../../Util';
import EditorImage from '../../common/editor/EditorImage';
import EditorSwitch from '../../common/editor/EditorSwitch';
import EditorTabPanel from '../../common/editor/EditorTabPanel';
import EditorUrlField from '../../common/editor/EditorUrlField';

// 🔹 i18n
import { useI18n } from '../../../i18n/I18nContext';

export default function BackgroundTab(props) {
  const {
    tabValue,
    tabIndex,
    thumbSrc,
    defaultThumbSrc,
    object,
    setObject
  } = props;

  const { t } = useI18n();
  const [backgroundError, setBackgroundError] = React.useState(null);

  return (
    <EditorTabPanel value={tabValue} index={tabIndex}>
      <div>
        <EditorUrlField
          sx={{ width: '50ch' }}
          label={t('backgroundLocationLabel')}
          value={Util.asString(thumbSrc)}
          helperText={backgroundError}
          color={backgroundError ? "warning" : undefined}
          focused={backgroundError ? true : false}
          onDropText={(text) => { setObject({ ...object, background: text }) }}
          onChange={(e) => { setObject({ ...object, background: e.target.value }) }}
        />
      </div>

      <div>
        <EditorSwitch
          label={t('backgroundPixelatedLabel')}
          tooltip={t('backgroundPixelatedTooltip')}
          onChange={(e) => {
            setObject({ ...object, backgroundPixelated: e.target.checked })
          }}
          checked={Util.asBoolean(object.backgroundPixelated)}
          sx={{ marginTop: .5 }}
        />
      </div>

      <div>
        <EditorImage
          src={thumbSrc}
          defaultSrc={defaultThumbSrc}
          errorCallback={setBackgroundError}
          onDropText={(text) => { setObject({ ...object, background: text }) }}
          sx={{
            objectFit: 'cover',
            height: '100%'
          }}
        />
      </div>
    </EditorTabPanel>
  );
}